import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var BarcodeIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M3 4a1 1 0 01.993.883L4 5v14a1 1 0 01-.883.993L3 20H2a1 1 0 01-.993-.883L1 19V5a1 1 0 01.883-.993L2 4h1zm3 0a1 1 0 01.993.883L7 5v14a1 1 0 01-1.993.117L5 19V5a1 1 0 011-1zm4 0a1 1 0 01.993.883L11 5v14a1 1 0 01-1.993.117L9 19V5a1 1 0 011-1zm9 0a1 1 0 01.993.883L20 5v14a1 1 0 01-1.993.117L18 19V5a1 1 0 011-1zm3 0a1 1 0 01.993.883L23 5v14a1 1 0 01-1.993.117L21 19V5a1 1 0 011-1zm-7 0a1 1 0 01.993.883L16 5v14a1 1 0 01-.883.993L15 20h-2a1 1 0 01-.993-.883L12 19V5a1 1 0 01.883-.993L13 4h2z",
                        fillRule: "evenodd"
                    })
                })
            })
        ]
    });
};
BarcodeIcon.isCarinaIcon = true;
export default BarcodeIcon;
